import getSdkSession from './utils/getSdkSession';

const Session = {

    /**
     *
     * @returns {Object} - a reference to the SDK session singleton
     *
     */

    getSdkSession,

    /**
     *
     * @access public
     * @desc Returns the current session info
     * @returns {Promise} Returns a promise that resolves with the session info
     *
     */
    async getSessionInfo() {
        const sdkSession = await Session.getSdkSession();
        const sessionInfo = await sdkSession.getSessionInfo();
        return sessionInfo;
    }

};

export default Session;
